import { createContext, useContext, useEffect, useState } from 'react';
import {
  getCurrentLifeEvent,
  getEnrollment,
  getFingertipsLinks,
  getHealthSavings,
  getHealthSnapshot,
  getTotalRewards,
} from '../services/dashboard';
import { AuthStore } from './auth';

export type DashboardState = {
  enrollment: any;
  currentLifeEvent: any;
  healthSnapshot: Array<any>;
  healthSavings: Array<any>;
  totalRewards: Array<any>;
  fingertipLinks: Array<any>;
};

export const DashboardStore = createContext<DashboardState>({
  enrollment: undefined,
  currentLifeEvent: undefined,
  healthSnapshot: [],
  healthSavings: [],
  totalRewards: [],
  fingertipLinks: [],
});

const { Provider } = DashboardStore;

export const DashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [dashboardState, setDashboardState] = useState<DashboardState>({
    enrollment: {},
    currentLifeEvent: {},
    healthSnapshot: [],
    healthSavings: [],
    totalRewards: [],
    fingertipLinks: [],
  });

  useEffect(() => {
    let enrollment = getEnrollment();
    let currentLifeEvent = getCurrentLifeEvent();
    let healthSnapshot = getHealthSnapshot();
    let healthSavings = getHealthSavings();
    let totalRewards = getTotalRewards();
    let fingertipLinks = getFingertipsLinks(selectedPersona);

    setDashboardState({
      enrollment,
      healthSnapshot,
      currentLifeEvent,
      healthSavings,
      totalRewards,
      fingertipLinks,
    });
  }, [selectedPersona]);

  return <Provider value={dashboardState}>{children}</Provider>;
};
